import Vue from 'vue';
import Vuex from 'vuex';
import VuexPerist from 'vuex-persist';

import auth from './auth';
import navigate from './navigate';

Vue.use(Vuex);

const vuexLocal = new VuexPerist({
  key: 'etax',
  storage: window.localStorage
})

const store = new Vuex.Store({
  modules: {
    auth,
    navigate
  },
  plugins: [
    vuexLocal.plugin
  ],
})

export default store;
